import { selector } from 'recoil';

import { auth } from 'src/lib/auth';

export const getUserEmailQuery = selector({
    key: 'GetUserEmail',
    get: (): string => {
        const profile = auth.getProfile();

        const userEmail = profile && profile.email;

        return typeof (userEmail) === 'string' ? userEmail : '';
    },
});
